"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import React, { type ReactNode, useMemo } from "react";
import { SIDEBAR_WIDTHS } from "../../constants/sidebar";
import { useSidebarController } from "../../hooks/useSidebarController";
import { SidebarProvider, useSidebarState } from "../../hooks/useSidebarState";
import ClientOnly from "../client-only/ClientOnly";
import WebSidebar from "./sidebar/WebSidebar";
const DESKTOP_MAX_WIDTH = 1324;
interface WebLayoutProps {
  readonly children: ReactNode;
  readonly isSmall?: boolean;
}
const WebLayoutContent = t0 => {
  const $ = _c(25);
  const {
    children,
    isSmall: t1
  } = t0;
  const isSmall = t1 === undefined ? false : t1;
  const {
    isMobile,
    isNarrow,
    isCollapsed,
    isOffcanvasOpen,
    toggleCollapsed,
    closeOffcanvas,
    sidebarWidth
  } = useSidebarController();
  const {
    isRightSidebarOpen
  } = useSidebarState();
  let t2;
  if ($[0] !== sidebarWidth) {
    t2 = {
      "--sidebar-width": sidebarWidth,
      "--collapsed-width": SIDEBAR_WIDTHS.COLLAPSED,
      "--expanded-width": SIDEBAR_WIDTHS.EXPANDED,
      "--layout-max": `${DESKTOP_MAX_WIDTH}px`
    };
    $[0] = sidebarWidth;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const cssVars = t2 as React.CSSProperties;
  const t3 = isSmall ? "true" : "false";
  let t4;
  if ($[2] !== closeOffcanvas || $[3] !== isCollapsed || $[4] !== isMobile || $[5] !== isNarrow || $[6] !== isOffcanvasOpen || $[7] !== sidebarWidth || $[8] !== toggleCollapsed) {
    t4 = <div className="tailwind-scope"><WebSidebar isCollapsed={isCollapsed} onToggle={toggleCollapsed} isMobile={isMobile} isNarrow={isNarrow} isOffcanvasOpen={isOffcanvasOpen} onCloseOffcanvas={closeOffcanvas} sidebarWidth={sidebarWidth} /></div>;
    $[2] = closeOffcanvas;
    $[3] = isCollapsed;
    $[4] = isMobile;
    $[5] = isNarrow;
    $[6] = isOffcanvasOpen;
    $[7] = sidebarWidth;
    $[8] = toggleCollapsed;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== children || $[11] !== isMobile || $[12] !== isNarrow || $[13] !== isOffcanvasOpen || $[14] !== isRightSidebarOpen) {
    t5 = <main className="layout-main tw-flex-1 tw-min-w-0" data-mobile={isMobile} data-narrow={isNarrow} data-offcanvas={isOffcanvasOpen} data-right-open={isRightSidebarOpen}>{children}</main>;
    $[10] = children;
    $[11] = isMobile;
    $[12] = isNarrow;
    $[13] = isOffcanvasOpen;
    $[14] = isRightSidebarOpen;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== cssVars || $[17] !== isMobile || $[18] !== isNarrow || $[19] !== isOffcanvasOpen || $[20] !== isRightSidebarOpen || $[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
    t6 = <div className="layout-root tw-flex tw-justify-between tw-relative tw-w-full" style={cssVars} data-mobile={isMobile} data-narrow={isNarrow} data-offcanvas={isOffcanvasOpen} data-right-open={isRightSidebarOpen} data-small={t3}>{t4}{t5}</div>;
    $[16] = cssVars;
    $[17] = isMobile;
    $[18] = isNarrow;
    $[19] = isOffcanvasOpen;
    $[20] = isRightSidebarOpen;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
const WebLayout = t0 => {
  const $ = _c(4);
  const {
    children,
    isSmall: t1
  } = t0;
  const isSmall = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tailwind-scope tw-min-h-[100dvh] tw-bg-black tw-flex tw-items-center tw-justify-center tw-px-6"><div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-8 tw-text-center md:tw-text-left"><Image unoptimized={true} priority={true} loading="eager" src="https://d3lqz0a4bldqgf.cloudfront.net/images/scaled_x450/0x33FD426905F149f8376e227d0C9D3340AaD17aF1/279.WEBP" alt="Brain" width={220} height={326} className="tw-rounded-md tw-shadow-lg tw-max-w-[40vw] md:tw-max-w-[180px] tw-h-auto" /><h1 className="tw-text-xl tw-font-bold tw-text-white">Loading...</h1></div></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== children || $[2] !== isSmall) {
    t3 = <SidebarProvider><ClientOnly fallback={t2}><WebLayoutContent isSmall={isSmall}>{children}</WebLayoutContent></ClientOnly></SidebarProvider>;
    $[1] = children;
    $[2] = isSmall;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default WebLayout;